module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "topbar"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/guide"
    }
  }, [_vm._v("Guide")])], 1), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://cdn.moip.com.br/wp-content/uploads/2017/01/15232848/logo-moip-wirecard.png",
      "width": "85px",
      "height": "35px",
      "alt": "Moip"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("checkout")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-29b63ed7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderDoc.vue
// module id = 132
// module chunks = 1